import PropTypes from 'prop-types';
import React from 'react';

import Classes from 'classnames';

class ExistingItem extends React.Component {
    static propTypes = {
        isSelected: PropTypes.bool,
        label: PropTypes.string,
        value: PropTypes.string,
        iconObj: PropTypes.object,
        parent: PropTypes.object
    };

    render() {
        const { isSelected, label, value, iconObj, parent} = this.props;

        const classes = Classes('status-tile', 'gd-scf-'+iconObj.color, {
            'selected': isSelected
        });

        return (
            <div className={classes} onClick={parent.onOptionClick.bind(parent, value)}>
                {label}
            </div>
        );
    }
}

module.exports = ExistingItem;